import React from 'react'
import { graphql } from 'gatsby-link'
import Helmet from 'react-helmet'
import ScrollToTop from 'react-scroll-up'
import Fade from 'react-reveal/Fade'

import news from '../assets/images/news.svg'
import warning from '../assets/images/warning.svg'
import clock from '../assets/images/clock.svg'
import map from '../assets/images/map.svg'
import arrow from '../assets/images/arrow.svg'

const Infos = ({ data: { prismicActus } }) => (
  <div>
    <Helmet>
      <html lang="fr" />
      <title>Informations</title>
      <meta
        name="description"
        content="Adresse horaires des séances et actualité"
      />
    </Helmet>

    <div id="main" className="alt">
      <section id="one">
        <div className="inner">
          <header className="major">
            <h1>Infos / Actus</h1>
          </header>
          <hr></hr>
          <Fade>
            <span className="img main">
              <img src={news} alt="icone journal" />
            </span>
            <h2>Actualités</h2>
            <div className="flexquote">
              <span className="image actus">
                <img src={prismicActus.data.image.url} alt="visuel pour actu" />
              </span>
              <blockquote>
                <h3>{prismicActus.data.titre.text}</h3>
                <p>{prismicActus.data.texte.text}</p>
                <a target="_blank" href={prismicActus.data.lien.url}>
                  Voir la page ...
                </a>
              </blockquote>
            </div>
            <hr></hr>
            <span className="img main">
              <img src={warning} alt="icone alerte" />
            </span>
            <h2>Rappel</h2>
            <p>Les séances se font sur rendez-vous exclusivement.</p>
            <hr></hr>
            <span className="img main">
              <img src={map} alt="icone d'une carte" />
            </span>
            <div className="row">
              <div className="6u 12u$(small)">
                <h2>Le cabinet</h2>
                <p>
                  La Grenière
                  <br />
                  Aubigny <br />
                  85430 Aubigny-les Clouzeaux
                </p>
                <a href="https://www.google.com/maps/place/Anne+GARNIER+R%C3%A9flexologue/@46.5311371,-1.7714428,11z/data=!4m8!1m2!2m1!1sanne+garnier!3m4!1s0x0:0x8bf6281c58a33a1f!8m2!3d46.5694825!4d-1.4665461">
                  Google Maps
                </a>
              </div>
              <div className="6u 12u$(small)">
                <h2>A domicile</h2>
                <p>secteur : Les Sables d'Olonne</p>
              </div>
            </div>
            <hr></hr>
            <span className="img main">
              <img src={clock} alt="icone d'une pendule" />
            </span>
            <h2>Horaires</h2>
            <div className="table-wrapper">
              <table className="alt">
                <thead>
                  <tr>
                    <th>Jour</th>
                    <th>Horaires</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>Lundi</td>
                    <td>
                      <b>9h - 12h30</b>
                    </td>
                  </tr>
                  <tr>
                    <td>Mercredi</td>
                    <td>
                      <b>9h - 19h</b>
                    </td>
                  </tr>
                  <tr>
                    <td>Vendredi</td>
                    <td>
                      <b>14h30 - 19h</b>
                    </td>
                  </tr>
                  <tr>
                    <td>Samedi</td>
                    <td>
                      <b>9h - 18h</b>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </Fade>
          <ScrollToTop showUnder={160}>
            <span className="img main">
              <img src={arrow} alt="icone fleche" />
            </span>
          </ScrollToTop>
        </div>
      </section>
    </div>
  </div>
)

export default Infos

export const pageQuery = graphql`
  query InfosQuery {
    prismicActus {
      data {
        titre {
          text
        }
        texte {
          text
        }
        image {
          url
        }
        lien {
          url
        }
      }
    }
  }
`



// WEBPACK FOOTER //
// ./src/pages/infos.js